import Vue from 'vue'
import Router from 'vue-router'
import FrontPage from '@/views/FrontPage.vue'
import EnrollPage from '@/views/Enroll.vue'
import AccountPage from '@/views/Account.vue'
import AboutUsPage from '@/views/AboutUs.vue'
import ScorePage from '@/views/Score.vue'
import RankPage from '@/views/Rank.vue'
import ProblemPage from '@/views/Problem.vue'
import ResourcePage from '@/views/Resources.vue'
import RulePage from '@/views/Rule.vue'
import SharePage from '@/views/Share.vue'
import NewsPage from '@/views/News.vue'
import JumpPage from '@/views/Jump.vue'
import UserPage from '@/views/User.vue'
import PreliminaryPage from '@/views/Preliminary.vue'
import RepechargePage from '@/views/Repecharge.vue'
import FinalPersonalPage from '@/views/FinalPersonal.vue'
import FinalGroupPage from '@/views/FinalGroup.vue'
import MdPage from '@/views/Md.vue'
import InsidePlayPage from '@/views/InsidePlay.vue'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'frontpage',
      component: RulePage
    },
    {
      path: '/play/:slug',
      name: 'PlayPageFinal',
      component: InsidePlayPage,
      props: true
    },
    {
      path: '/user',
      name: 'User',
      component: UserPage
    },
    {
      path: '/preliminary',
      name: 'Preliminary',
      component: PreliminaryPage
    },
    {
      path: '/repecharge22',
      name: 'Repecharge22',
      component: RepechargePage
    },
    {
      path: '/final-personal',
      name: "FinalPersonal",
      component: FinalPersonalPage
    },
    {
      path: '/final-group',
      name: "FinalGroup",
      component: FinalGroupPage
    },
    {
      path: '/share/:uuid/:title',
      name: 'Share',
      component: SharePage,
    },
    {
      path: '/score',
      name: 'score',
      component: ScorePage
    },
    {
      path: '/rank/:me',
      name: 'rank',
      component: RankPage
    },
    {
      path: '/news',
      name: 'news',
      component: NewsPage
    },
    {
      path: '/problem',
      name: 'problem',
      component: ProblemPage
    },
    {
      path: '/resource',
      name: 'resource',
      component: ResourcePage
    },
    {
      path: '/enroll',
      name: 'enroll',
      component: EnrollPage
    },
    {
      path: '/rule',
      name: 'rule',
      component: RulePage
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: AboutUsPage
    },
    {
      path: '/account/:type',
      name: 'account',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: AccountPage
      // import(/* webpackChunkName: "about" */ './views/About.vue')
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
